import React from 'react'
import './index.scss'
import {SimpleBlueButton} from '../button'
import classNames from 'classnames'

function LargeCard({style, icon, iconSize, tag, title, content, onClick, highlight, disabled, buttonText, className = '', isDarkMode}) {
    return (
        <div className={classNames('large-card', {
            [className]: !!className,
            dark: isDarkMode
        })} style={style}>
            <div className='card-head'>
                <img className='card-icon' src={icon} height={iconSize || 64} alt={title} />
                {tag && <div className='card-tag'>{tag}</div>}
            </div>
            <div className="card-body">
                <div className="card-title">
                    {title}
                </div>
                <div className="card-content">
                    {content}
                </div>
            </div>
            <SimpleBlueButton
                onClick={onClick}
                className={`card-button ${highlight ? 'has-shadow' : ''}`}
                disabled={disabled}
            >
                {buttonText}
            </SimpleBlueButton>
        </div>
    )
}

export default LargeCard
